import React from "react";
import "./CustomPagination.css";

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const visiblePages = 2;
    const pages = [];

    const half = Math.floor(visiblePages / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, currentPage + half);

    if (start > 1) {
      pages.push(1);
      if (start > 2) pages.push("...");
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="custom-pagination">
      <button
        disabled={currentPage === 1}
        className="cp-arrow-btn"
        onClick={() => onPageChange(currentPage - 1)}
      >
        &#8592;
      </button>

      {getPageNumbers().map((page, index) =>
        page === "..." ? (
          <span key={index} className="cp-dots">
            ...
          </span>
        ) : (
          <button
            key={index}
            className={`cp-page-btn ${currentPage === page ? "active" : ""}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        )
      )}

      <button
        disabled={currentPage === totalPages}
        className="cp-arrow-btn"
        onClick={() => onPageChange(currentPage + 1)}
      >
        &#8594;
      </button>
    </div>
  );
};

export default CustomPagination;
